import { environment } from '../../../environments/environment';

const apiRoute = environment.apiRoute;

export default apiRoute;
